import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_BILLING_SERVER } from '@/app/module/dashboard/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetBilling = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const skip = !orgId
  const res = esApi.endpoints.getOrgBilling.useQuery({ orgId: orgId.toString() }, { skip })

  useEffect(() => {
    if (!res.error) return
    dispatch(
      createNotification({
        'get-billing-error': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_BILLING_SERVER),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}

export default useGetBilling
